import { Mode } from './Mode.js';
import { QRData } from './QRData.js';
/**
 * QRKanji(SJIS only)
 *
 * @author Kazuhiko Arase
 */
export class QRKanji extends QRData {
    stringToBytes;
    constructor(data, stringToBytes) {
        super(Mode.MODE_KANJI, data);
        this.stringToBytes = stringToBytes;
    }
    write(buffer) {
        const data = this.stringToBytes(this.getData());
        let i = 0;
        while (i + 1 < data.length) {
            let c = ((0xff & data[i]) << 8) | (0xff & data[i + 1]);
            if (0x8140 <= c && c <= 0x9ffc) {
                c -= 0x8140;
            }
            else if (0xe040 <= c && c <= 0xebbf) {
                c -= 0xc140;
            }
            else {
                throw new Error('illegal char at ' + (i + 1) + '/' + c);
            }
            c = ((c >>> 8) & 0xff) * 0xc0 + (c & 0xff);
            buffer.put(c, 13);
            i += 2;
        }
        if (i < data.length) {
            throw new Error('illegal char at ' + (i + 1));
        }
    }
    getLength() {
        return this.stringToBytes(this.getData()).length / 2;
    }
}
//# sourceMappingURL=QRKanji.js.map